import {
  RESET_METRICS,
  FETCH_METRICS_FILTERS,
  FETCH_METRICS_START,
  FETCH_METRICS_PROGRESS,
  FETCH_METRICS_SUCCESS,
  FETCH_METRICS_FAIL
} from "../actions";

export const FETCH_METRICS_FILTERS_SUCCESS = "FETCH_METRICS_FILTERS_SUCCESS";
export const FETCH_METRICS_FILTERS_FAIL = "FETCH_METRICS_FILTERS_FAIL";

export const defaultMetricsState = {
  metrics: null,
  filters: null,
  filtersLoading: false,
  loading: false,
  runId: null,
  runStatus: null,
  progress: null,
  error: null,
};

export default (state = defaultMetricsState, action) => {
  switch (action.type) {
    case FETCH_METRICS_START:
      return {
        ...state,
        metrics: null,
        loading: true,
        runId: null,
        runStatus: "pending",
        progress: null,
        error: null,
      };
    case FETCH_METRICS_PROGRESS:
      return {
        ...state,
        loading: action.payload?.status === "failed" ? false : state.loading,
        runId: action.payload?.runId || state.runId,
        runStatus: action.payload?.status || state.runStatus,
        progress: {
          ...(state.progress || {}),
          ...(action.payload || {}),
        },
      };
    case FETCH_METRICS_SUCCESS:
      return {
        ...state,
        metrics: action.payload.result || action.payload.data || null,
        loading: false,
        runId: action.payload.runId || state.runId,
        runStatus: "completed",
        progress: action.payload.progress || state.progress,
        error: null,
      };
    case RESET_METRICS:
      return {
        ...state,
        metrics: null,
        loading: false,
        runId: null,
        runStatus: null,
        progress: null,
        error: null,
      };
    case FETCH_METRICS_FILTERS:
      return {
        ...state,
        filtersLoading: true,
      };
    case FETCH_METRICS_FAIL:
      return {
        ...state,
        metrics: null,
        loading: false,
        runId: action.payload?.runId || state.runId,
        runStatus: "failed",
        progress: state.progress ? {
          ...state.progress,
          status: "failed",
          error: action.payload?.error,
        } : null,
        error: action.payload?.error || null,
      };
    case FETCH_METRICS_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload.data,
        filtersLoading: false,
      };
    case FETCH_METRICS_FILTERS_FAIL:
      return {
        ...state,
        filters: null,
        filtersLoading: false,
      };
    default:
      return {
        ...state
      };
  }
};
